/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cv_Extract_Form_Academictitle_Label1Inputs */

const en_cv_extract_form_academictitle_label1 = /** @type {(inputs: Cv_Extract_Form_Academictitle_Label1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desired Academic Degree`)
};

const de_cv_extract_form_academictitle_label1 = /** @type {(inputs: Cv_Extract_Form_Academictitle_Label1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Angestrebter akademischer Titel`)
};

/**
* | output |
* | --- |
* | "Desired Academic Degree" |
*
* @param {Cv_Extract_Form_Academictitle_Label1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const cv_extract_form_academictitle_label1 = /** @type {((inputs?: Cv_Extract_Form_Academictitle_Label1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Extract_Form_Academictitle_Label1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cv_extract_form_academictitle_label1(inputs)
	return en_cv_extract_form_academictitle_label1(inputs)
});
export { cv_extract_form_academictitle_label1 as "cv_extract_form_academicTitle_label" }